import { LoadState } from "../../constants/enums";
import { IServiceState, IServiceCategory, IServiceItem } from "./service.types";

export const initialServiceCategory: IServiceCategory = {
  service_category_uuid: null,
  company_outlet_uuid: "",
  service_category_name: "",
  service_category_description: "",
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export const initialServiceItem: IServiceItem = {
  service_item_uuid: null,
  service_category_uuid: "",
  service_category_name: "",
  description: "",
  service_item_name: "",
  fill_quantity: false,
  total_quantity: 0,
  company_outlet_uuid: "",
  total_price: 0,
  variant: [],
  rule_for_upsell: [],
  attachments: [],
  reference_url: [],
  preferred_event: [],
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export const initialServiceState: IServiceState = {
  serviceCategory: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  serviceItem: {
    data: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
